import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = { class: "element-box" }
const _hoisted_3 = { class: "table-responsive overflow-auto pt-4" }
const _hoisted_4 = { class: "table table-striped" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { key: 0 }

import overviewCoachingService from '@/api/CoachingOverview/PrivateCoaching';
import CreateButton from '@/components/CreateButton.vue';
import Loader from '@/components/Loader.vue';
import PageTemplate from '@/components/PageTemplate.vue';
import Pagination from '@/components/Pagination.vue';
import PerPage from '@/components/PerPage.vue';
import {CloseToast, ErrorToast} from '@/components/VueToast';
import router from '@/router';
// @ts-ignore
import {getFinishedUnemployedDropdown, getOfficeByUserRoleDropdown, getUserDropdown} from '@/shared/dropdowns';
import {piniaEnumsStore} from '@/store/piniaEnumsStore';
import Search from '@/views/App/CoachingOverview/PrivateCoaching/Inquiry/Search.vue';
import {computed, onMounted, ref} from 'vue';
import {ICoachingOverviewList, IPagination} from "@/interfaces/CoachingOverview/PrivateCoaching/ICoachingOverview";
import {ICoachingOverviewFilters} from "@/interfaces/CoachingOverview/ICoachingOverviewFIlters";
import BackButton from "@/components/button/BackButton.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'List',
  setup(__props) {

const piniaEnumsState = piniaEnumsStore();
const getEnums = computed(() => piniaEnumsState.enums);
const unemployedDropdown = ref([]);
const coachDropdown = ref([]);
const operationTypeDropdown = ref([]);
const officeDropdown = ref([]);
const isSearching = ref(false);
const isLoaded = ref(false);

const inquiryList = ref<ICoachingOverviewList>({
  data: [],
  pagination: {
    current_page: 1,
    items_per_page: 10,
    total_pages: 0,
  } as IPagination,
});

const statusFiltered = computed(() => {
  return piniaEnumsState.enums?.coachingStatus?.filter((status: { value: string }) =>
      status.value === 'in_allocation' ||
      status.value === 'accepted' ||
      status.value === 'approval_pending'
  );
});

const filters = ref<ICoachingOverviewFilters>({
  unemployedId: '',
  coachId: '',
  officeId: '',
  operationType: '',
  startDate: '',
  endDate: '',
  status: '',
  page: 1,
  limit: 10,
  sortBy: 'firstName',
  searchTerm: '',
  orderBy: 'ASC',
});

async function getInquiryList(
    page: number | undefined = 1,
    perPage?: number,
    passedFilters?: ICoachingOverviewFilters
) {
  CloseToast();

  if (passedFilters) {
    isSearching.value = true;
  }
  const perPageRes = inquiryList.value?.pagination?.items_per_page;

  try {
    const {data} = await overviewCoachingService.getInquiryOverviewList({
      ...(passedFilters ? passedFilters : filters.value),
      page: page,
      limit: perPage ?? perPageRes,
    });

    inquiryList.value = data;
    isSearching.value = false;
  } catch (error) {
    await ErrorToast(error);
    isSearching.value = false;
  }
}

async function getOperationTypeDropdown() {
  operationTypeDropdown.value = getEnums?.value?.privateCoachingOperationTypes || [];
}

onMounted(async () => {
  await Promise.all([
    getInquiryList(),
    getFinishedUnemployedDropdown(unemployedDropdown),
    getUserDropdown(coachDropdown),
    getOfficeByUserRoleDropdown(officeDropdown),
    getOperationTypeDropdown(),
  ]);

  isLoaded.value = true;
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PageTemplate, null, {
    default: _withCtx(() => [
      (!isLoaded.value)
        ? (_openBlock(), _createBlock(Loader, { key: 0 }))
        : (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(BackButton, {
              label: _ctx.$t('general.button.back'),
              to: { name: 'coachingOverview' },
              marginBottom: "5"
            }, null, 8, ["label"]),
            _cache[2] || (_cache[2] = _createElementVNode("h6", { class: "element-header" }, "Übersicht", -1)),
            _createElementVNode("div", _hoisted_2, [
              _cache[1] || (_cache[1] = _createElementVNode("h5", { class: "form-header mb-4" }, "Einzelcoaching Anfrage", -1)),
              _createVNode(Search, {
                filters: filters.value,
                loading: isSearching.value,
                unemployedDropdown: unemployedDropdown.value,
                operationTypeDropdown: operationTypeDropdown.value,
                officeDropdown: officeDropdown.value,
                coachDropdown: coachDropdown.value,
                statusDropdown: statusFiltered.value,
                onSearch: getInquiryList
              }, null, 8, ["filters", "loading", "unemployedDropdown", "operationTypeDropdown", "officeDropdown", "coachDropdown", "statusDropdown"]),
              _createVNode(PerPage, {
                values: [10, 25, 50, 100],
                "onUpdate:perPage": getInquiryList
              }),
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("table", _hoisted_4, [
                  _cache[0] || (_cache[0] = _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", { class: "text-center" }, "Kunde"),
                      _createElementVNode("th", null, "Status"),
                      _createElementVNode("th", null, "Maßnahmenart"),
                      _createElementVNode("th", null, "JC/AA Nr"),
                      _createElementVNode("th", null, "Vorname"),
                      _createElementVNode("th", null, "Nachname"),
                      _createElementVNode("th", null, "Standort"),
                      _createElementVNode("th", null, "Coach"),
                      _createElementVNode("th", null, "Sachbearbeiter"),
                      _createElementVNode("th", null, "Start"),
                      _createElementVNode("th", null, "Ende"),
                      _createElementVNode("th", null, "Stand")
                    ])
                  ], -1)),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(inquiryList.value.data, (coaching) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: coaching.id
                      }, [
                        _createElementVNode("td", null, [
                          _createElementVNode("button", {
                            class: "btn btn-primary",
                            onClick: ($event: any) => (_unref(router).push({
                  name: 'unemployedPrivateCoachingList', params: {
                    id: Number(coaching.unemployed.id )
                  } }))
                          }, " Kunde ", 8, _hoisted_5)
                        ]),
                        _createElementVNode("td", null, _toDisplayString(coaching?.statusTranslated), 1),
                        _createElementVNode("td", null, _toDisplayString(coaching?.nameOfCoaching?.operationTypeTranslated), 1),
                        _createElementVNode("td", null, _toDisplayString(coaching?.unemployed?.aaNumber), 1),
                        _createElementVNode("td", null, _toDisplayString(coaching?.unemployed?.firstName), 1),
                        _createElementVNode("td", null, _toDisplayString(coaching?.unemployed?.lastName), 1),
                        _createElementVNode("td", null, [
                          (coaching.type === 'regular')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(_toDisplayString(coaching?.unemployed?.location?.name), 1)
                              ], 64))
                            : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(coaching.offices, (office, index) => {
                                return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                                  _createTextVNode(_toDisplayString(office?.office?.name), 1)
                                ], 64))
                              }), 128))
                        ]),
                        _createElementVNode("td", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(coaching.coaches, (coach, index) => {
                            return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                              _createTextVNode(_toDisplayString(coach?.firstName) + " " + _toDisplayString(coach?.lastName), 1),
                              (index !== coaching.coaches.length - 1)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_6, ", "))
                                : _createCommentVNode("", true)
                            ], 64))
                          }), 128))
                        ]),
                        _createElementVNode("td", null, _toDisplayString(coaching.clerk), 1),
                        _createElementVNode("td", null, _toDisplayString(coaching.startDate), 1),
                        _createElementVNode("td", null, _toDisplayString(coaching.endDate), 1),
                        _createElementVNode("td", null, _toDisplayString(coaching.unitsDone), 1)
                      ]))
                    }), 128))
                  ])
                ])
              ]),
              (inquiryList.value?.pagination?.total_pages > 1)
                ? (_openBlock(), _createBlock(Pagination, {
                    key: 0,
                    totalPages: inquiryList.value?.pagination?.total_pages,
                    currentPage: inquiryList.value?.pagination?.current_page,
                    totalItems: inquiryList.value?.pagination?.total_items,
                    perPage: inquiryList.value?.pagination?.items_per_page,
                    onPagechanged: getInquiryList
                  }, null, 8, ["totalPages", "currentPage", "totalItems", "perPage"]))
                : _createCommentVNode("", true)
            ])
          ]))
    ]),
    _: 1
  }))
}
}

})